/**
 * Created by Dell on 12-02-2020.
 */
export const getDomain = () =>{
    var full = window.location.host;
    var parts = full.split('.');
    if(parts.length > 1 && full.indexOf('localhost') >= 0){
        console.debug("GetDomain Inside 1st If ",parts[0]);
        return parts[0]
    }
    if(parts.length > 2 && full.indexOf('esignandpay.net') >= 0){
        console.debug("GetDomain Inside 2nd If ",parts[0]);
        return parts[0]
    }
    if(parts.length > 2 && full.indexOf('esignandpay.com') >= 0){
        console.debug("GetDomain Inside 3rd If ",parts[0]);
        return parts[0]
    }else{
        console.debug("GetDomain Inside else ");
        return null;
    }
}

/*Common function handle success response*/
export const successResponse = (apiStatus, response) =>{
    apiStatus.isError = false;
    apiStatus.message = response.message;
    apiStatus.messages = response.messages;
};

/*Common function handle error response*/
export const errorResponse = (apiStatus, response) => {
    console.log(response);
    apiStatus.isError = true;
    apiStatus.message = response.message;
    apiStatus.messages = response.messages;
};

/*Common function handle catch error response*/
export const errorCatchResponse = (apiStatus, response) => {
    console.log(response);
    apiStatus.isError = true;
    apiStatus.message = response;
};

export const formatMoney = (number, decPlaces, decSep, thouSep) => {
    decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces;
        decSep = typeof decSep === "undefined" ? "." : decSep;
    thouSep = typeof thouSep === "undefined" ? "," : thouSep;
    var sign = number < 0 ? "-" : "";
    var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces), 10));
    /* var j = 0;
     j = (j = i.length) > 3 ? j % 3 : 0;
         return sign +
             (j ? i.substr(0, j) + thouSep : "") +
             i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
             (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
         */

        var lastThree = i.substring(i.length-3);
        var otherNumbers = i.substring(0,i.length-3);
        if(otherNumbers !== '')
            lastThree = ',' + lastThree;
        sign = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",")+lastThree+
            (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
        return sign;

}

export const validateBusinessEmail = (email, restrictedEmail) => {
    var splittedRestrictedEmail = restrictedEmail.split(",")
    var isBusinessEmail = true
    var splittedEmail = email.split("@")
    for(var i=0; i<splittedRestrictedEmail.length; i++){
        if(splittedEmail[1].indexOf(splittedRestrictedEmail[i]) > -1){
            isBusinessEmail = false
        }
    }
    if(isBusinessEmail){
       return true
    }else{
        return false
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Util.js